import type { IScope } from "angular";
import { cloneDeep, isEmpty, isEqual } from "lodash";
import { finalize } from "rxjs/operators";

import type { IPartner, IResponseWithLoading } from "App/Modules/Models";
import type { IPartnersRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditMindcareSettingsComponentController {
    public static $inject: string[] = ["$scope", "mmPartnersRepository"];

    public original: IPartner;

    public edited: IPartner;

    public resolve: IFormContainerResolve<IPartner, void>;

    public editResponse: IResponseWithLoading<IPartner>;

    constructor(private readonly $scope: IScope, private readonly partnersRepository: IPartnersRepository) {}

    public $onInit() {
        this.original = this.resolve.formData;
        this.edited = cloneDeep(this.original);
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public editMindcareSettings() {
        const patchObject = {} as IPartner;

        if (!isEqual(this.edited.supervisionTimeWindowMinutes, this.original.supervisionTimeWindowMinutes)) {
            patchObject.supervisionTimeWindowMinutes = this.edited.supervisionTimeWindowMinutes;
        }

        if (!isEqual(this.edited.cameraMaxMinutes, this.original.cameraMaxMinutes)) {
            patchObject.cameraMaxMinutes = this.edited.cameraMaxMinutes;
        }

        if (!isEmpty(patchObject)) {
            extendWithLoadingAndFail(this.partnersRepository.patch(this.original.id, patchObject))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<IPartner>) => {
                        this.editResponse = response;

                        if (!response.isLoading && response.data) {
                            this.resolve.options.onOk(response.data);
                        }
                    },
                    (error) => {
                        this.editResponse = error;
                    },
                );
        } else {
            this.cancel();
        }
    }
}
